import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ClaimFinalizeComponent } from './finalize/claim-finalize.component';
import { ClaimVerificationComponent } from './verification/claim-verification.component';
import { ClaimGuardService } from './claim.guard.service';
import { ManualClaimComponent } from './manual-claim/manual-claim.component';

const routes: Routes = [
  { path: '', component: ClaimVerificationComponent },
  { path: 'verification', component: ClaimVerificationComponent, data: { step: 1} },
  { path: 'finalize', component: ClaimFinalizeComponent, data: { step: 2 } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [
    ClaimGuardService,
  ]
})
export class ClaimRoutingModule { }
